import { render, staticRenderFns } from "./HomeEvents.vue?vue&type=template&id=202fa330"
import script from "./HomeEvents.vue?vue&type=script&lang=js"
export * from "./HomeEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports